export default "__VITE_ASSET__BYX$NPdI__"